import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('SMOKE_PUFF', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  for (let i = 0; i < 10; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const dist = progress * 60 * rnd;
    const x = e.pos.x + Math.cos(angle) * dist;
    const y = e.pos.y + Math.sin(angle) * dist - progress * 30;

    ctx.fillStyle = determineColor(i, 10);
    ctx.globalAlpha = (1 - progress) * 0.5;
    ctx.beginPath(); ctx.arc(x, y, 10 + progress * 20, 0, Math.PI * 2); ctx.fill();
  }
});
